import React from "react";
import {Chart} from "react-chartjs-2";
export const Matrix = props => <Chart type="matrix" {...props} />